<template>
  <div>
    <a-dropdown>
      <div class="header-avatar" style="cursor: pointer">
        <a-avatar class="avatar" size="small" shape="circle" :src="user.headImg"/>
        <span class="name">{{ user.deptName }}-{{ user.name }}</span>
      </div>
      <a-menu :class="['avatar-menu']" slot="overlay">
        <!--      <a-menu-item>-->
        <!--        <a-icon type="user" />-->
        <!--        <span>个人中心</span>-->
        <!--      </a-menu-item>-->
        <!--      <a-menu-item>-->
        <!--        <a-icon type="setting" />-->
        <!--        <span>设置</span>-->
        <!--      </a-menu-item>-->

        <a-menu-item @click="show = true">
          <a-icon type="setting"/>
          <span>修改密码</span>
        </a-menu-item>
        <a-menu-divider/>
        <a-menu-item @click="logout">
          <a-icon style="margin-right: 8px;" type="poweroff"/>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <!--  设置密码  -->
    <a-modal
        title="设置新密码"
        centered
        :maskClosable="false"
        :visible="show"
        :closable="false"
        :footer="null"
        :width="600"
    >
      <setPassword
          ref="setPassword"
          @cancel="show = false"
          @save="logout"
      >
      </setPassword>
    </a-modal>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
import {logout} from '@/services/user'
import {dataApi} from '@/services/login/login';
//弹出层组件
import setPassword from "@/layouts/header/setPassword";

export default {
  name: 'HeaderAvatar',
  components: {setPassword},
  computed: {
    ...mapGetters('account', ['user']),
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    async logout() {
      this.show = false;
      await dataApi.logout().then(() => {
        logout();
        if (!process.env.VUE_APP_LOGOUT_SERVICE_URL) {
          this.$router.push('/login')
        } else {
          location.replace(process.env.VUE_APP_LOGOUT_SERVICE_URL)
        }
      })
    }
  }
}
</script>

<style lang="less">
.header-avatar {
  display: inline-flex;

  .avatar, .name {
    align-self: center;
  }

  .avatar {
    margin-right: 8px;
  }

  .name {
    font-weight: 500;
  }
}

.avatar-menu {
  width: 150px;
}

</style>
